var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFbMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6738 0.006242L11.7835 0C7.41284 0 4.58833 2.89785 4.58833 7.38304V10.7871H0.67678C0.338776 10.7871 0.0650635 11.0611 0.0650635 11.3991V16.3313C0.0650635 16.6693 0.339088 16.943 0.67678 16.943H4.58833V29.3883C4.58833 29.7263 4.86204 30 5.20005 30H10.3035C10.6415 30 10.9152 29.726 10.9152 29.3883V16.943H15.4887C15.8267 16.943 16.1005 16.6693 16.1005 16.3313L16.1023 11.3991C16.1023 11.2369 16.0377 11.0814 15.9232 10.9666C15.8086 10.8517 15.6526 10.7871 15.4903 10.7871H10.9152V7.90144C10.9152 6.51447 11.2457 5.81037 13.0525 5.81037L15.6732 5.80943C16.0109 5.80943 16.2846 5.53541 16.2846 5.19772V0.617958C16.2846 0.280578 16.0112 0.0068662 15.6738 0.006242Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbMobile);
export default __webpack_public_path__ + "static/media/fb-mobile.8fc727bf8f3931df0015356a98e5b95c.svg";
export { ForwardRef as ReactComponent };